import React from 'react';
import SolutionTab from './CreateSolution';
import GroupTab from './GroupCreation';

function Create ({ tab }) {

    switch (tab) {
        case "Solution":
            return <SolutionTab />;
        case "Group":
            return <GroupTab />;
    }
}

export default Create;